import { create, getAll, getById, remove } from './baseService';

// Endpoint cơ bản cho files
const endpoint = 'files';

// Tải lên file (upload)
const fileService = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file); // Thêm file vào FormData

    return create(endpoint, formData); // Gọi API `POST /files`
  },

  // Lấy danh sách file
  getFiles : async () => {
    return getAll(endpoint); // Gọi API `GET /files`
  },

  // Lấy file theo ID (trả về blob để tạo link)
  getFileById: async (id) => {
    const response = await getById(endpoint, id);

    if (response.error) {
      return { data: null, error: response.error };
    }

    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    const downloadURL = URL.createObjectURL(fileBlob);

    return { data: downloadURL, error: null }; // Trả về link tải xuống
  },

  // Xóa file
  deleteFile : async (id) =>  {
    return remove(endpoint, id); // Gọi API `DELETE /files/:id`
  }

}

export default fileService
